import React from "react";
import Text from "./Text";
import { BUTTON_CONFIG } from "config/constants/Button";

const Button = ({
  onClick = null,
  full: bIsFull = false,
  label: sLabel = null,
  size: nSize = BUTTON_CONFIG.SIZE.MD,
  className: sCustomClassName = "",
  type: sType = BUTTON_CONFIG.CLASS.PRIMARY,
  containerClassName: sContainerClassName = "",
  icon: oIcon = null,
  active: isActive = false,
  iconPosition: sIconPosition = BUTTON_CONFIG.POSITION.RIGHT,
  disabled: bDisabled = false,
}) => {
  const aClassName = [
    "ui-btn",
    "cursor-pointer",
    "inline-flex",
    "items-center",
    "justify-center",
    "gap-1",
    "rounded-md",
    "font-medium",
    "border",
    "border-solid",
    "text-center",
    "whitespace-nowrap",
    "transition-colors",
    "duration-150",
  ];
  let sLabelColor = null;

  switch (sType) {
    // Rediseño: SUCCESS (antes verde) es el botón secundario neutro, con borde fino
    case BUTTON_CONFIG.CLASS.SUCCESS:
      aClassName.push(
        "ui-btn-neutral",
        "bg-white dark:bg-gray-800",
        "border-line-strong dark:border-gray-600",
        "hover:bg-gray-50 dark:hover:bg-gray-700",
        "hover:border-gray-400 dark:hover:border-gray-500",
      );
      sLabelColor = "text-gray-700 dark:text-gray-200";
      break;
    case BUTTON_CONFIG.CLASS.DANGER:
      aClassName.push(
        "ui-btn-neutral",
        "bg-white dark:bg-gray-800",
        "border-red-300 dark:border-red-800",
        "hover:bg-red-50 dark:hover:bg-gray-700",
        "hover:border-red-400 dark:hover:border-red-700",
      );
      sLabelColor = "text-red-600 dark:text-red-400";
      break;
    case BUTTON_CONFIG.CLASS.OUTLINE:
      aClassName.push(
        "bg-transparent",
        "border-transparent",
        "border-b-[1px]",
        "border-b-gray-700 dark:border-b-gray-200",
        "hover:border-[1px]",
        "hover:rounded-md hover:border-gray-200",
      );
      if (isActive)
        aClassName.push(
          "border-[1px]",
          "rounded-md border-gray-200",
        );
      else
        aClassName.push("rounded-none");
      sLabelColor = "text-gray-700 dark:text-gray-200";
      break;
    // Rediseño: PRIMARY es la acción principal de la pantalla, en el azul de la marca
    case BUTTON_CONFIG.CLASS.PRIMARY:
    default:
      aClassName.push(
        "ui-btn-filled",
        "bg-primary-500 border-primary-500",
        "hover:bg-primary-600 hover:border-primary-600",
        "dark:bg-primary-600 dark:border-primary-600 dark:hover:bg-primary-700 dark:hover:border-primary-700",
      );
      sLabelColor = "text-white";
      break;
  }

  const aLabelClassName = ["m-auto"];

  switch (nSize) {
    case BUTTON_CONFIG.SIZE.XS:
      aLabelClassName.push("text-xs");
      aClassName.push("py-0.5", "px-2");
      break;
    case BUTTON_CONFIG.SIZE.SM:
      aLabelClassName.push("text-sm");
      aClassName.push("py-1", "px-3");
      break;
    case BUTTON_CONFIG.SIZE.MD:
    default:
      aLabelClassName.push("text-sm");
      aClassName.push("py-1.5", "px-4");
      break;
    case BUTTON_CONFIG.SIZE.LG:
      aLabelClassName.push("text-base");
      aClassName.push("py-2", "px-5");
      break;
    case BUTTON_CONFIG.SIZE.XL:
      aLabelClassName.push("text-xl");
      aClassName.push("py-6", "px-12");
      break;
  }

  if (bIsFull) aClassName.push("w-full");

  if (bDisabled) aClassName.push("opacity-50", "cursor-not-allowed");

  aClassName.push(sCustomClassName);

  return (
    <div className={sContainerClassName}>
      <button className={`${aClassName.join(" ")} ${sLabelColor}`} onClick={bDisabled ? undefined : onClick}>
        {oIcon && sIconPosition === BUTTON_CONFIG.POSITION.LEFT && oIcon}
        {sLabel ? (
          <Text color={sLabelColor} className={aLabelClassName.join(" ")}>
            {sLabel}
          </Text>
        ) : null}
        {oIcon && sIconPosition === BUTTON_CONFIG.POSITION.RIGHT && oIcon}
      </button>
    </div>
  );
};

export default Button;
